import React, { useEffect, useState } from "react";
import api from "../../services/api";
import T from "../../assets/styles/theme";
import { resolveNotifRoute } from "../../utils/notifRouteResolver";
import "../../assets/styles/PM/PMNotifPg.css";

function PMNotifPg({ onNavigate }) {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const rows = await api.getPMNotifications();
      setNotifs(Array.isArray(rows) ? rows : []);
      setErrorMsg("");
    } catch (e) {
      setNotifs([]);
      setErrorMsg(e.message || "Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {load();}, []);

  const markAll = async () => {
    try {
      await api.markAllNotificationsRead();
      setNotifs((prev) => prev.map((n) => ({ ...n, is_read: true, unread: false })));
    } catch (e) {
      setErrorMsg(e.message || "Unable to mark all as read");
    }
  };

  const openItem = async (n) => {
    setSelected(n);
    if (n.id && !n.is_read) {
      await api.markPMNotificationRead(n.id).catch(() => {});
      setNotifs((prev) => prev.map((x) => x.id === n.id ? { ...x, is_read: true, unread: false } : x));
    }
  };

  const gotoModule = (n) => {
    if (!onNavigate) return;
    const tab = resolveNotifRoute(n, 'pm');
    onNavigate(tab);
  };

  return (
    <div>
      <div className="sec">Notifications</div>
      {errorMsg &&
      <div className="toast pmnotifpg-inline-1">
          {errorMsg}
        </div>
      }
      <div className="cd pmnotifpg-inline-2">
        <div className="cd-h">
          <div className="cd-t">All Notifications</div>
          <div className="cd-s">{notifs.filter((n) => n.unread || !n.is_read).length} unread</div>
          <button className="btn-o btn-s" onClick={markAll}>Mark all as read</button>
        </div>
        <div className="cd-b pmnotifpg-inline-3">
          {loading ? <div style={{ "--pmnotifpg-1-color": T.textMuted }} className="pmnotifpg-dyn-1">Loading...</div> :
          notifs.length === 0 ? <div style={{ "--pmnotifpg-2-color": T.textMuted }} className="pmnotifpg-dyn-2">No notifications</div> :
          notifs.map((n, i) =>
          <div key={n.id || i} onClick={() => openItem(n)} style={{ "--pmnotifpg-3-border-bottom":
            `1px solid ${T.border}`, "--pmnotifpg-3-background": selected?.id === n.id ? "#eef2ff" : n.unread || !n.is_read ? "#f8fafc" : "#fff" }} className="pmnotifpg-dyn-3">
                  <div className="pmnotifpg-inline-4">{n.title || "Notification"}</div>
                  <div style={{ "--pmnotifpg-4-color": T.textMuted }} className="pmnotifpg-dyn-4">{n.body || n.text || ""}</div>
                </div>
          )}
        </div>
      </div>
      {selected &&
      <div className="cd">
          <div className="cd-h"><div className="cd-t">Notification Detail</div></div>
          <div className="cd-b">
            <div className="pmnotifpg-inline-5">{selected.title || "Notification"}</div>
            <div className="pmnotifpg-inline-6">{selected.body || selected.text || selected.message || "-"}</div>
            <div className="pmnotifpg-inline-7">{selected.type || "system"}</div>
            <div className="pmnotifpg-inline-8">
              <button className="btn" onClick={() => gotoModule(selected)}>Open Module</button>
            </div>
          </div>
        </div>
      }
    </div>);

}

export default PMNotifPg;